import ObservationTableHeader from './ObservationTableHeader';
import ObservationTable from './ObservationTable';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import {
  ObservationTableHeaderViewModeEnum,
  transformObservationHeaders,
  transformObservationValues,
} from '../utils';
import { useDataAnnotation } from '../context/DataAnnotationProvider';

const ObservationResults = () => {
  const { observations } = useSelector(
    (state: RootState) => state.dataAnnotation,
  );
  const { currentCase } = useDataAnnotation();
  const observationHeaders = transformObservationHeaders(
    observations,
    currentCase?.eventDate || new Date().toISOString(),
    ObservationTableHeaderViewModeEnum.DATA_ANNOTATION,
  );
  const observationValues = transformObservationValues(
    observations,
    currentCase?.eventDate || new Date().toISOString(),
    ObservationTableHeaderViewModeEnum.DATA_ANNOTATION,
  );
  const havingData = observationValues.length > 0;
  return (
    <div className="d-flex flex-column p-3 w-50 h-100 ">
      <ObservationTableHeader headerData={observationHeaders} />
      {havingData ? (
        <>
          <ObservationTable observationData={observationValues} />
        </>
      ) : (
        <span className="roboto font-12">No data available</span>
      )}
    </div>
  );
};

export default ObservationResults;
